import {getPluginConfig} from './start-ui';

let clickOutsideHandler = [];

let loremWords = [
    'Lorem', 'ipsum', 'dolor', 'sit', 'amet', 'consectetur', 'adipiscing', 'elit', 'curabitur', 'vel', 'hendrerit',
    'libero', 'eleifend', 'blandit', 'nunc', 'ornare', 'odio', 'ut', 'orci', 'gravida', 'imperdiet', 'nullam', 'purus',
    'lacinia', 'a', 'pretium', 'quis', 'congue', 'praesent', 'sagittis', 'laoreet', 'auctor', 'mauris', 'non', 'velit',
    'eros', 'dictum', 'proin', 'accumsan', 'sapien', 'nec', 'massa', 'volutpat', 'venenatis', 'sed', 'eu', 'molestie',
    'lacus', 'quisque', 'porttitor', 'ligula', 'dui', 'mollis', 'tempus', 'at', 'magna', 'vestibulum', 'turpis', 'ac',
    'diam', 'tincidunt', 'id', 'condimentum', 'enim', 'sodales', 'in', 'hac', 'habitasse', 'platea', 'dictumst',
    'aenean', 'neque', 'fusce', 'augue', 'leo', 'eget', 'semper', 'mattis', 'tortor', 'scelerisque', 'nulla',
    'interdum', 'tellus', 'malesuada', 'rhoncus', 'porta', 'sem', 'aliquet', 'et', 'nam', 'suspendisse', 'potenti',
    'vivamus', 'luctus', 'fringilla', 'erat', 'donec', 'justo', 'vehicula', 'ultricies', 'varius', 'ante', 'primis',
    'faucibus', 'ultrices', 'posuere', 'cubilia', 'curae', 'etiam', 'cursus', 'aliquam', 'quam', 'dapibus', 'nisl',
    'feugiat', 'egestas', 'class', 'aptent', 'taciti', 'sociosqu', 'ad', 'litora', 'torquent', 'per', 'conubia',
    'nostra', 'inceptos', 'himenaeos', 'phasellus', 'nibh', 'pulvinar', 'vitae', 'urna', 'iaculis', 'lobortis', 'nisi',
    'viverra', 'arcu', 'morbi', 'pellentesque', 'metus', 'commodo', 'ut', 'facilisis', 'felis', 'tristique',
    'ullamcorper', 'placerat', 'aenean', 'convallis', 'sollicitudin', 'integer', 'rutrum', 'duis', 'est', 'etiam',
    'bibendum', 'donec', 'pharetra', 'vulputate', 'maecenas', 'mi', 'fermentum', 'consequat', 'suscipit', 'aliquam',
    'habitant', 'senectus', 'netus', 'fames', 'quisque', 'euismod', 'curabitur', 'lectus', 'elementum', 'tempor',
    'risus', 'cras',
];

export function delay(timeout) {
    return new Promise(resolve => {
        setTimeout(resolve, timeout);
    });
}

export function stripTags(str) {
    return (str||'').replace(/&nbsp;|<br>/ig, " ").replace(/(<([^>]+)>)/ig, "");
}

export function formatNumber(value, fixed = null) {
    let {thousandsSeparator, floatSeparator} = getPluginConfig('ui');

    value = Number(value||0);
    if (fixed !== null) {
        value = value.toFixed(fixed);
    }

    let [real, float] = value.toString().split(/[.,]/);
    let negative = real.startsWith('-');

    real = real.replace(/^-/, '')
        .split("").reverse().join("")
        .replace(/(\d{3})(?!$)/g, `$1${thousandsSeparator}`)
        .split("").reverse().join("");

    return (negative ? '-' : '') + real + (float ? `${floatSeparator}${float}` : '');
}

export function isEmpty(value) {
    let type = typeof value;
    return value === null
        || type === "undefined"
        || (type === "string"  && value.replace(/&nbsp;/gi, '').trim() === '')
        || (value instanceof Array && value.length === 0)
        || (value instanceof Object && Object.keys(value).length === 0);
}

export function handleClickOutside(ev) {
    for (let {handler, except} of clickOutsideHandler) {
        if (typeof except === "string") {
            except = document.querySelectorAll(except);
        } else if (!(except instanceof Array)) {
            except = [except];
        }

        let clickedOutside = true;
        for (let exceptNode of except) {
            if (exceptNode === ev.target || nodeHasParent(ev.target, exceptNode)) {
                clickedOutside = false;
                break;
            }
        }
        if (clickedOutside) {
            handler(ev);
        }
    }
}

export function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}

export function addClickOutsideHandler(handler, except) {
    setTimeout(() => {
        // timout to prevent triggering when added through click event (propagation behavior)
        if (clickOutsideHandler.length === 0) {
            document.addEventListener('click', handleClickOutside);
        }
        clickOutsideHandler.push({handler, except});
    }, 5);
}

export function removeClickOutsideHandler(handler) {
    let index = clickOutsideHandler.findIndex(config => config.handler === handler);

    if (~index) {
        clickOutsideHandler.splice(index, 1);
    }

    if (clickOutsideHandler.length === 0) {
        document.removeEventListener('click', handleClickOutside);
    }
}

export function nodeHasParent(node, parent) {
    if (!(node instanceof Node) || !(parent instanceof Node)) {
        return false;
    }

    while (node) {
        node = node.parentNode;
        if (node === parent) {
            return true;
        }
    }

    return false;
}

export const scrollingElement = document.scrollingElement || document.body.parentNode || document.body || document.documentElement; // ie11 :|

export function scrollTo(to, duration = 250, node = null) {
    node = node || scrollingElement;

    let start = node.scrollTop;
    let change = to - start;
    let currentTime = 0;
    let increment = 20;

    if (duration === 0) {
        node.scrollTop = to;
        return;
    }

    let animateScroll = () => {
        currentTime += increment;
        node.scrollTop = easeInOutQuad(currentTime, start, change, duration);
        if (currentTime < duration) {
            setTimeout(animateScroll, increment);
        }
    };
    animateScroll();
}

// https://gist.github.com/andjosh/6764939
export function easeInOutQuad(t, b, c, d) {
    t /= d/2;
    if (t < 1) {
        return c/2*t*t + b;
    }
    t--;
    return -c/2 * (t*(t-2) - 1) + b;
}

export function scrollToElement(node, offset = 0) {
    if (typeof node === "string") {
        node = document.querySelector(node);
    }
    if (!(node instanceof Node)) {
        return;
    }
    let {top} = node.getBoundingClientRect();
    scrollTo(scrollingElement.scrollTop + top - offset);
}

export function lorem(count) {
    let words = [];
    for (let i = 0; i < count; i++) {
        words.push(loremWords[i % loremWords.length]);
    }
    return words.join(' ');
}

export function matchesSelector(node, selector) { // ie11 :|
    let matches = node.matches || node.msMatchesSelector;
    return matches.call(node, selector);
}
